// extracted by mini-css-extract-plugin
export default {"statsItem":"NodeCardStats_statsItem__yEsbx","statsContainer":"NodeCardStats_statsContainer__HCGct"};